export function isIE(ie: string): boolean {
  const IE: string = `${ie}`.replace(/[^\d]+/g, '').trim();
  return IE === ie;
}
